import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RedirectWhatsappPage } from './redirect-whatsapp.page';

const routes: Routes = [
  {
    path: '',
    component: RedirectWhatsappPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RedirectWhatsappPageRoutingModule {}
